import { IconButton } from '@/decodo/components/atoms/IconButton';

import IconXClose from '~/icons/x-close.svg';

export function MenuSheetCloseButton({ onClose }: { onClose: () => void }) {
  return (
    <IconButton
      variant='text'
      color='secondary'
      size='s'
      classNames={{
        root: 'absolute right-0 top-4 p-0 text-gray-500 hover:text-gray-700',
      }}
      onClick={onClose}
    >
      <IconXClose viewBox='0 0 24 24' className='h-full w-full' />
    </IconButton>
  );
}
